import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { TimeoutError } from 'rxjs';
import { QrPaymentRedirectServiceService } from './qr-payment-redirect-service.service';

@Component({
  selector: 'app-qr-payment-redirect',
  templateUrl: './qr-payment-redirect.component.html',
  styleUrls: ['./qr-payment-redirect.component.scss']
})
export class QrPaymentRedirectComponent implements OnInit {

  isRedirecting = false;
  isLoading = true;
  errorMessage: string | null = null;

  private bookingId: string | null = null;
  private xpcnId: string | null = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly qrPaymentService: QrPaymentRedirectServiceService
  ) {}

  ngOnInit(): void {
    console.log('QR ROUTE HIT');
    this.bookingId = this.route.snapshot.queryParamMap.get('bookingId');
    this.xpcnId = this.route.snapshot.queryParamMap.get('xpcnId');

    console.log('QrPaymentRedirect - params received:', {
      bookingId: this.bookingId,
      xpcnId: this.xpcnId
    });

    this.initiatePayment();
  }

  private initiatePayment(): void {
    console.log('QrPaymentRedirect - calling Generate-Payment-QR API');

    // Wait up to 60 seconds for a response before treating it as a failure.
    this.qrPaymentService.generatePaymentQR(this.bookingId, this.xpcnId)
      .pipe(timeout(60000))
      .subscribe({
        next: (response: any) => {
          const redirectUrl = response?.Success ? response?.RedirectUrl : null;

          console.log('QrPaymentRedirect - received redirect URL:', redirectUrl);

          // if (redirectUrl) {
          //   window.location.href = redirectUrl;
          // }
          if (redirectUrl) {
  this.isLoading = false;
  this.isRedirecting = true;

  setTimeout(() => {
    window.location.replace(redirectUrl);
  }, 1500);
} 
          else {
            console.error('QrPaymentRedirect - API returned failure or no URL. Message:', response?.Message);
            this.isLoading = false;
            this.errorMessage = 'Unable to initiate payment. Please try again or contact support.';
          }
        },
        error: (err) => {
          if (err instanceof TimeoutError) {
            console.error('QrPaymentRedirect - API did not respond within 60 seconds.');
            this.isLoading = false;
            this.errorMessage = 'Payment initiation timed out. Please try again or contact support.';
          } else {
            console.error('QrPaymentRedirect - API call failed:', err);
            this.isLoading = false;
            this.errorMessage = 'Something went wrong while initiating payment. Please try again or contact support.';
          }
        }
      });
  }
}

